'use client';
import React__default, { createContext, useState, useEffect } from 'react';
import { handleDecisionRendering } from '../../utils/handleDecisionRendering.js';
import { clientSide } from '../../utils/dom.js';

const CohesionContext = /*#__PURE__*/createContext({});
const BricksContext = /*#__PURE__*/createContext({});
const withCohesion = _ref => {
  let {
    App,
    Layout,
    assets,
    defaultFuseNumber = '',
    callMonarchWithPreamp = () => false,
    debug = false
  } = _ref;
  const isAppProps = props => {
    return props.Component !== undefined;
  };
  if (clientSide && debug) {
    if (!window.Bricks) {
      window.Bricks = {};
    }
    window.Bricks.debug = true;
  }
  const BricksCohesionProvider = props => {
    const [preampDecisions, setPreampDecisions] = useState();
    const [renderedDecisions, setRenderedDecisions] = useState();
    const [monarchResponse, setMonarchResponse] = useState();
    const [monarchAutoCallResponse, setMonarchAutoCallResponse] = useState();
    const [fuseNumber, setFuseNumber] = useState('');
    useEffect(() => {
      handleDecisionRendering({
        callMonarchWithPreamp,
        setRenderedDecisions: setRenderedDecisions,
        preampDecisions,
        monarchResponse,
        monarchAutoCallResponse,
        renderedDecisions
      });
    }, [preampDecisions, monarchResponse, monarchAutoCallResponse, renderedDecisions]);
    return /*#__PURE__*/React__default.createElement(BricksContext.Provider, {
      value: {
        setMonarchResponse,
        setMonarchAutoCallResponse,
        setRenderedDecisions
      }
    }, /*#__PURE__*/React__default.createElement(CohesionContext.Provider, {
      value: {
        assets,
        preampDecisions,
        setPreampDecisions,
        monarchResponse,
        monarchAutoCallResponse,
        renderedDecisions,
        defaultFuseNumber,
        fuseNumber,
        setFuseNumber,
        callMonarchWithPreamp
      }
    }, isAppProps(props) && App && props.Component && /*#__PURE__*/React__default.createElement(App, props), !isAppProps(props) && Layout && props.children && /*#__PURE__*/React__default.createElement(Layout, props)));
  };
  return BricksCohesionProvider;
};

export { BricksContext, CohesionContext, withCohesion };
